/* Decorative motion never gates content, changes layout or delays the hero. */
(() => {
  const preference = matchMedia('(prefers-reduced-motion: reduce)');
  class StudioMotion {
    constructor(root) {
      this.root = root;
      this.regions = [...(root.matches('[data-studio-motion]') ? [root] : []), ...root.querySelectorAll('[data-studio-motion]')];
      this.buttons = [...root.querySelectorAll('.pd-studio-motion-toggle')];
      this.update = () => { this.regions.forEach(region => region.classList.toggle('motion-allowed', !preference.matches)); this.buttons.forEach(button => { button.hidden = preference.matches; }); };
      this.click = event => {
        const button = event.target.closest('.pd-studio-motion-toggle');
        if (!button) return;
        const region = button.closest('[data-studio-motion]');
        const paused = region.classList.toggle('motion-paused');
        button.setAttribute('aria-pressed', String(paused));
        button.textContent = paused ? button.dataset.playLabel : button.dataset.pauseLabel;
      };
      this.observer = new IntersectionObserver(entries => entries.forEach(entry => entry.target.classList.toggle('motion-visible', entry.isIntersecting)), {threshold: .12});
      this.regions.forEach(region => this.observer.observe(region));
      this.buttons.forEach(button => { button.hidden = preference.matches; });
      this.update();
      root.addEventListener('click', this.click);
      preference.addEventListener('change', this.update);
    }
    destroy() { this.observer.disconnect(); this.root.removeEventListener('click', this.click); preference.removeEventListener('change', this.update); }
  }
  if (!customElements.get('pd-range-story')) customElements.define('pd-range-story', class extends HTMLElement {
    connectedCallback() {
      const main = document.querySelector('product-info[id^="MainProduct-"]');
      if (main) this.querySelectorAll('[data-pd-v-buy]').forEach(link => { link.href = '#' + main.id; });
      if (this.dataset.motion === 'true' && 'IntersectionObserver' in window) this.motion = new StudioMotion(this);
    }
    disconnectedCallback() { this.motion?.destroy(); }
  });
  if (!customElements.get('pd-studio-motion')) customElements.define('pd-studio-motion', class extends HTMLElement {
    connectedCallback() { if ('IntersectionObserver' in window) this.motion = new StudioMotion(this); }
    disconnectedCallback() { this.motion?.destroy(); }
  });
})();
